import { PaymentMethodFee } from "./PaymentMethodFeeModel";

export class PaymentMethod{
    name!:string;
    type!:string;
    totalAmount!:number;
    config!:any;
    fee!: PaymentMethodFee;
}